/* eslint-disable react/no-unstable-nested-components */
import { CompanyEventsTabEnum } from "components/company/v3/menu/enums";
import type { CalendarInterval, EventsCalendarState } from "components/investorrelations/EventsCalendarLocalState";
import { EventsCalendarFilterRange, EventsCalenderFilterEventType } from "components/investorrelations/enums";
import addMonths from "date-fns/addMonths";
import subMonths from "date-fns/subMonths";
import type { ReactElement } from "react";
import { useState } from "react";
import type { IIssuerType } from "types/graphqlTypes";
import { IOrderDirection } from "types/graphqlTypes";

interface CompanyStateProps<T> {
  tab: T;
  onChangeTab: (tab: T) => void;
}

interface CompanyLocalStateProps<T> {
  defaultTab: T;
  children: (state: CompanyStateProps<T>) => ReactElement;
}

const CompanyLocalState = <T extends string>({ children, defaultTab }: CompanyLocalStateProps<T>) => {
  const [tab, setTab] = useState<T>(defaultTab);

  return children({
    tab,
    onChangeTab: setTab,
  });
};

export default CompanyLocalState;

type CompanyEventsLocalStateChildrenProps = EventsCalendarState & {
  tab: CompanyEventsTabEnum;
  onChangeTab: (tab: CompanyEventsTabEnum) => void;
};

interface CompanyEventsLocalStateProps {
  children: (state: CompanyEventsLocalStateChildrenProps) => ReactElement;
}

export function CompanyEventsLocalState({ children }: CompanyEventsLocalStateProps) {
  const currentDate = new Date();

  const [tab, setTab] = useState<CompanyEventsTabEnum>(CompanyEventsTabEnum.CALENDAR);
  const [myPositions, setMyPositions] = useState(false);
  const [isInSP500, setIsInSP500] = useState(false);
  const [isInBookmarks, setIsInBookmarks] = useState(false);
  const [searchQuery, setSearchQuery] = useState<string | null>(null);
  const [eventType, setEventType] = useState<EventsCalenderFilterEventType | null>(EventsCalenderFilterEventType.All);
  const [issuerType, setIssuerType] = useState<IIssuerType | null>(null);
  const [period, setPeriod] = useState(EventsCalendarFilterRange.InTheYear);
  const [orderBy, setOrderBy] = useState(IOrderDirection.Ascending);
  const [calendarInterval, setCalendarInterval] = useState<CalendarInterval>({
    startDate: subMonths(currentDate, 6),
    endDate: addMonths(currentDate, 6),
  });

  return children({
    tab,
    onChangeTab: setTab,

    myPositions,
    isInSP500,
    isInBookmarks,
    searchQuery,
    eventType,
    issuerType,
    period,
    orderBy,
    calendarInterval,

    setMyPositions,
    setIsInSP500,
    setIsInBookmarks,
    setSearchQuery,
    setEventType,
    setIssuerType,
    setPeriod,
    setOrderBy,
    setCalendarInterval,
  });
}
